import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import axios from 'axios';
import toast from 'react-hot-toast';
import { HeartIcon } from '@heroicons/react/24/outline';
import { HeartIcon as HeartSolidIcon } from '@heroicons/react/24/solid';

const LikeButton = ({ projectId, initialLikeCount = 0, initialIsLiked = false }) => {
  const { user, isAuthenticated } = useAuth();
  const queryClient = useQueryClient();
  const [isLiked, setIsLiked] = useState(initialIsLiked);
  const [likeCount, setLikeCount] = useState(initialLikeCount);

  // Récupérer les likes du projet
  useQuery(
    ['project-likes', projectId],
    async () => {
      const response = await axios.get(`/api/projects/${projectId}/likes`);
      return response.data;
    },
    {
      enabled: !!projectId,
      onSuccess: (data) => {
        setLikeCount(data.likeCount);
        if (user) {
          const userLike = data.likes.find(like => like.userId === user.id);
          setIsLiked(!!userLike);
        }
      }
    }
  );

  // Mutation pour liker/unliker
  const likeMutation = useMutation(
    async () => {
      const response = await axios.post(`/api/projects/${projectId}/like`);
      return response.data;
    },
    {
      onSuccess: (data) => {
        setIsLiked(data.isLiked);
        setLikeCount(data.likeCount);
        
        // Invalider les caches liés
        queryClient.invalidateQueries(['project-likes', projectId]);
        queryClient.invalidateQueries('projects');
        queryClient.invalidateQueries(['project', projectId]);
        
        toast.success(data.message);
      },
      onError: (error) => {
        console.error('Erreur like:', error);
        toast.error('Erreur lors du like');
      }
    }
  );

  const handleLike = () => {
    if (!isAuthenticated) {
      toast.error('Vous devez être connecté pour liker un projet');
      return;
    }
    
    likeMutation.mutate();
  };

  return (
    <button
      onClick={handleLike}
      disabled={likeMutation.isLoading}
      className={`flex items-center space-x-2 px-3 py-2 rounded-lg transition-colors ${
        isLiked 
          ? 'bg-red-50 text-red-600 hover:bg-red-100' 
          : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
      } ${!isAuthenticated ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
      title={isAuthenticated ? (isLiked ? 'Retirer le like' : 'Liker ce projet') : 'Connectez-vous pour liker'}
    >
      {isLiked ? (
        <HeartSolidIcon className="h-5 w-5" />
      ) : (
        <HeartIcon className="h-5 w-5" />
      )}
      <span className="text-sm font-medium">
        {likeCount > 0 ? likeCount : ''}
      </span>
    </button>
  );
};

export default LikeButton;

